
import { companyURL } from 'endpoints';
import fetch from './utils/fetch.js';

let company = null;

export const getCompany = async ( companyId ) => {
    if ( company ) {
        return company;
    }
    if ( companyId ) {
        const res = await fetch( `${ companyURL }/graphql`, {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify(
                {
                    query: `query companyQuery($companyId: String!) {
                        company(id: $companyId) {
                            id
                            name
                            contactEmailAddress
                            primaryLogo
                            primaryColor
                            secondaryLogo
                            secondaryColor
                            supportingColor
                            defaultLocaleCode
                        }
                    }
                    `,
                    variables: { companyId }
                }
            )
        } );

        const { data } = await res.json();
        company = data.company;
        return company;
    }
};
